/** Battle UI layout grid cell size (matches dev GridOverlay / logical stage). */
export const BATTLE_LAYOUT_GRID_CELL_PX = 20;

/** How long player/opponent emote bubbles stay visible at the zone cross. */
export const BATTLE_EMOTE_DISPLAY_DURATION_MS = 2000;

/** 1-based column for emote picker lower-left anchor. */
export const BATTLE_EMOTE_PICKER_ANCHOR_CELL_COL = 29;

/** 1-based row for emote picker lower-left anchor. */
export const BATTLE_EMOTE_PICKER_ANCHOR_CELL_ROW = 42;

/**
 * Lower-left corner of a 1-based layout grid cell in logical stage pixels.
 */
export function getBattleLayoutCellBottomLeftPx(col, row, cellPx = BATTLE_LAYOUT_GRID_CELL_PX) {
  if (!Number.isInteger(col) || col < 1) {
    throw new Error(`getBattleLayoutCellBottomLeftPx: invalid col ${col}`);
  }
  if (!Number.isInteger(row) || row < 1) {
    throw new Error(`getBattleLayoutCellBottomLeftPx: invalid row ${row}`);
  }
  return {
    left: (col - 1) * cellPx,
    top: row * cellPx,
  };
}

/**
 * Emote picker anchor: lower-left of popup at the lower-left of the given cell.
 * Clamps vertical anchor to stage height on shorter canvases (mobile).
 */
export function getBattleEmotePickerAnchorPx(layoutBaseHeight) {
  if (!Number.isFinite(layoutBaseHeight) || layoutBaseHeight <= 0) {
    throw new Error('getBattleEmotePickerAnchorPx: layoutBaseHeight is required');
  }
  const cell = getBattleLayoutCellBottomLeftPx(
    BATTLE_EMOTE_PICKER_ANCHOR_CELL_COL,
    BATTLE_EMOTE_PICKER_ANCHOR_CELL_ROW
  );
  return {
    left: cell.left,
    top: Math.min(cell.top, layoutBaseHeight),
  };
}
